<lum-stock-ag-table
  class="lum-c-stock"
  [currentStockStatus]="(currentStockStatus$ | async) || null"
  [currentCustomFilter]="(currentCustomFilter$ | async) || null"
  [warehouseGroups]="(warehouseGroups$ | async) || []"
>
  <lum-ag-grid-sidemenu
    sideMenu
    [menuItems]="sideMenuItems"
    [config]="sideMenuItemConfig"
    [activeMenu]="activeFilter"
    [enableCustomFilters]="true"
    [loadingCustomFilters]="(loadingCustomFilters$ | async) || false"
    [customFilters]="(customFilters$ | async) || []"
    (setActiveMenuItemEvent)="onSetStatus($event)"
    (setFilterEvent)="onSetFilter($event)"
    (saveFilterEvent)="onSaveFilter()"
  ></lum-ag-grid-sidemenu>
</lum-stock-ag-table>
